import styled from 'styled-components';
import { HOME, LOGIN, PRIVACY, TERMS } from '../../constants/routes';
import Link from 'next/link';
import Typography, { TypeVariant } from '../../shared/Typography';
import { ReactNode } from 'react';

const Container = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background: var(--background, transparent);
  padding-bottom: var(--spacing-40);

  @media ${(p) => p.theme.queries.phoneAndDown} {
    flex-direction: column;
    padding-bottom: var(--spacing-80);
  }
`;

const Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-24);

  @media ${(p) => p.theme.queries.phoneAndDown} {
    width: 100%;
    flex-direction: column;
  }
`;

const LinkWrap = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: var(--color-gray-500);

  &:hover {
    text-decoration: revert;
  }
`;

interface TextProps {
  children: ReactNode | ReactNode[];
}

const Text = ({ children }: TextProps) => (
  <Typography
    variant={TypeVariant.body01Bold}
    as="p"
    color="var(--color-gray-500)"
    textAlign="center"
  >
    {children}
  </Typography>
);

interface Props {
  background?: string;
}

export const Footer = ({ background }: Props) => (
  <Container style={{ '--background': background }}>
    <Wrap>
      <Text>Solin © 2021</Text>
      <Link href={HOME} passHref>
        <LinkWrap>
          <Text>Home</Text>
        </LinkWrap>
      </Link>
      <Link href={LOGIN} passHref>
        <LinkWrap>
          <Text>Sign In</Text>
        </LinkWrap>
      </Link>
      <Link href="mailto:info@solinfitness.com" passHref>
        <LinkWrap>
          <Text>Contact</Text>
        </LinkWrap>
      </Link>
      <Link href={PRIVACY} passHref>
        <LinkWrap>
          <Text>Privacy Policy</Text>
        </LinkWrap>
      </Link>
      <Link href={TERMS} passHref>
        <LinkWrap>
          <Text>Terms</Text>
        </LinkWrap>
      </Link>
    </Wrap>
  </Container>
);

export default Footer;
